import styled from "styled-components";

// 메인페이지 운동추천 컴포넌트
export const MainExerciseBox = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const MainExerciseTit = styled.h3`
  gap: 4px;
  display: flex;
  font-size: 1.8rem;
  font-weight: 600;
  align-items: center;

  div {
    display: flex;
    align-items: center;
  }
`;

export const MainExerciseRecomBox = styled.div`
  gap: 8px;
  display: flex;
  position: relative;
  flex-direction: column;
`;

export const MainExerciseRecomTit = styled.h4`
  gap: 6px;
  display: flex;
  font-size: 1.6rem;
  font-weight: 600;
  align-items: center;
`;

export const MainExerciseRecomText = styled.div`
  display: flex;
  font-size: 1.4rem;
  font-weight: 400;
  color: ${(props) => props.theme.colors.primary100};
`;

export const MainExerciseRecomSubText = styled.div`
  display: flex;
  font-size: 1.2rem;
  font-weight: 300;
  color: ${(props) => props.theme.colors.text2};

  white-space: pre-line;
`;

export const DdayBox = styled.div`
  color: ${(props) => props.theme.colors.white100};
  display: flex;
  padding: 5px 7px;
  font-size: 1rem;
  background: ${(props) => props.theme.colors.black80};
  font-weight: 600;
  border-radius: 4px;
  letter-spacing: initial;
`;

export const MainExerciseRecom = styled.div`
  left: -16px;
  width: 100vw;
  height: 320px;
  position: relative;
`;

export const MainExerciseThumbnail = styled.div`
  width: 100vw;
  height: 320px;
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #737373 40%,
    #737373 60%,
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    #737373 40%,
    #737373 60%,
    transparent 100%
  );

  img {
    width: 100%;
    height: 320px;
    object-fit: cover;
    object-position: center;
  }
`;

export const MainExerciseInfo = styled.div`
  left: 16px;
  width: calc(100vw - 32px);
  height: 80px;
  bottom: 80px;
  display: flex;
  padding: 20px 20px 20px 30px;
  position: relative;
  box-shadow: ${(props) => props.theme.shadows.box};
  background: ${(props) => props.theme.colors.white100};
  align-items: center;
  border-radius: 40px;
  justify-content: space-between;
`;

export const MainInfoTit = styled.div`
  gap: 6px;
  display: flex;
  font-size: 1.6rem;
  font-weight: 600;
  flex-direction: column;
`;

export const MainWeekInfoTime = styled.div`
  gap: 3px;
  color: ${(props) => props.theme.colors.primary100};
  display: flex;
  font-size: 1.2rem;
  font-weight: 400;
  align-items: center;

  svg {
    path {
      fill: ${(props) => props.theme.colors.primary100};
    }
  }
`;

export const MainIconBox = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.primaryBg};

  svg {
    width: 24px;
    height: 24px;
  }
`;

// 카드형 운동 추천 컴포넌트
export const ExerciseRecomBox = styled.div`
  gap: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ExerciseRecomTit = styled.h3`
  color: ${(props) => props.theme.colors.text4};
  font-size: 1.8rem;
  font-weight: 600;
`;

export const ExerciseRecom = styled.div`
  width: 100%;
  display: grid;
  overflow: hidden;
  box-shadow: ${(props) => props.theme.shadows.box};
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  grid-template-rows: 140px 70px;
`;

export const ExerciseThumbnail = styled.div`
  width: 100%;
  height: 130px;

  img {
    width: 100%;
    height: 130px;
    object-fit: cover;
    object-position: center;
  }
`;

export const ExerciseInfo = styled.div`
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: space-between;

  &:active {
    background: ${(props) => props.theme.colors.primary5};
  }
`;

export const InfoTit = styled.div`
  gap: 3px;
  display: flex;
  font-size: 1.6rem;
  font-weight: 700;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.1rem;
    font-weight: 400;
  }
`;

export const WeekExerciseRecomBox = styled.div`
  gap: 12px;
  display: flex;
  min-width: 250px;
  flex-shrink: 0;
  flex-direction: column;
`;

export const WeekExerciseRecom = styled.div`
  width: 100%;
  display: grid;
  overflow: hidden;
  box-shadow: ${(props) => props.theme.shadows.box};
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  grid-template-rows: 130px 70px;
`;

export const WeekExerciseThumbnail = styled.div`
  width: 100%;
  height: 140px;

  img {
    width: 100%;
    height: 130px;
    object-fit: cover;
    object-position: center;
  }
`;

export const WeekExerciseInfo = styled.div`
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: space-between;

  &:active {
    background: ${(props) => props.theme.colors.primary5};
  }
`;

export const WeekInfoTit = styled.div`
  gap: 8px;
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.1rem;
    font-weight: 400;
  }
`;

export const WeekInfoTime = styled.div`
  gap: 3px;
  color: ${(props) => props.theme.colors.black50};
  display: flex;
  font-size: 1.1rem;
  font-weight: 400;
  align-items: center;
`;
